











































import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import defineAbilityFor from "@/services/ability";
import router from "@/sites/admin/router";
import { GroupDTO, ROLES } from "@/model/user";
import { AuthService } from "@/common/api/services/AuthService";
import { AuthLoginRequest } from "@/common/api/index";
import ForgotPassword from "@/sites/admin/pages/forgotPassword.vue";
import { AppVersion } from "@/common/utils";

const auth = namespace("Auth");

@Component({
  name: "LoginPage",
  components: {
    ForgotPassword,
  },
  directives: {},
})
export default class LoginPage extends Vue {
  private user: AuthLoginRequest = {
    email: "",
    password: "",
    group_id: null,
  };
  private errorMessage = "";
  public appVersion = AppVersion();

  @auth.Getter
  userLogging: any;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateRefreshToken!: (refreshToken: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  setUser!: (user) => void;
  @auth.Action
  fetchCurrentUser!: () => void;
  @auth.Action
  updateUsingGroup!: (id: string) => void;
  @auth.Action
  updateGroupUsers!: (groups: GroupDTO) => void;

  protected created() {
    this.user.group_id =
      Number.parseInt(
        this.$router.currentRoute.query.token?.toString().split(".")[1]
      ) || null;
  }

  private async submit() {
    let response: any;
    try {
      response = await AuthService.authLogin(this.user);
    } catch (error: any) {
      response = error.body;
    }

    if (response.status == "error") {
      this.errorMessage = response.message;
      return;
    }

    const user = response.data.user;

    // Save it to state
    this.updateToken(response.data.token);
    this.updateRefreshToken(response.data?.refresh_token);
    if (user.role == ROLES.GROUP_ADMIN && response.data.group_id) {
      this.updateUsingGroup(response.data.group_id);
    }
    await this.fetchCurrentUser();

    // Set ability
    this.$ability.update(defineAbilityFor(user.role).rules);

    if (user.role == ROLES.GROUP_ADMIN) {
      return router.push({ name: "admin.info" });
    }

    return router.push({ name: "admin.user" });
  }

  public showForgotPasswordPopup() {
    (this.$refs.ForgotPasswordPopup as ForgotPassword).show();
  }
}
